import { EntityConfig } from './types';

export const WORKBOOK_CONFIG: EntityConfig = {
  entityType: 'workbook',
  tableName: 'workbook_research_attachments_disabled',
  entityIdColumn: 'workbook_id',
  researchLimit: 3,
  queryKey: ['attached-research'],
  displayName: 'Workbook Research (Disabled)'
};
